import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CourseCardPaper = styled(Paper)`
  height: 198px;
  border-radius: 10px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

  @media only screen and (max-width: 767px) {
    height: 134px;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    margin-bottom: 0px;
    border-radius: 0px;
    border-top: 1px solid rgba(0, 0, 0, 0.16);
    border-bottom: 1px solid rgba(0, 0, 0, 0.16);
  }

  .course-card-detail-box {
    width: 966px;
    height: 150px;
    align-self: center;
    justify-content: center;
    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      justify-content: start;
    }

    @media only screen and (max-width: 767px) {
      width: 289px;
      height: 102px;
    }
  }

  .course-card-image-box {
    width: 380px;
    height: 150px;
    margin-left: 24px;
    gap: 40px;
    display: flex;
    flex-direction: row;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      width: 257px;
    }

    @media only screen and (max-width: 767px) {
      width: 123px;
      height: 73px;
      margin-left: 0px;
      align-self: center;
      gap: 0px;
    }
  }

  .course-card-no-box {
    width: 83px;
    height: 86px;
    padding: 0px 24px;
    gap: 8px;
    align-items: center;
    align-self: center;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 1199px) {
      display: none;
      width: 0px;
    }
  }

  .course-card-info-box {
    width: 546px;
    margin-left: 40px;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 1199px) and (min-width: 768px) {
      margin-left: 24px;
    }

    @media only screen and (max-width: 767px) {
      width: 150px;
      height: 88px;
      margin-left: 16px;
      align-self: center;
    }
  }

  .course-card-instructors-info-box {
    display: flex;
    flex-direction: row;
  }

  .ribbon-certificate-box {
    position: absolute;
    right: 15px;
    left: auto;
    margin-top: 30px;

    @media screen and (max-width: 767px) {
      position: absolute;
      left: 17px;
      right: auto;
      margin-top: 30px;
    }
  }

  .image {
    @media only screen and (max-width: 767px) {
      width: 123px;
      height: 71px;
      border: 1px solid #eeeeee;
      border-radius: 8px;
    }
  }

  .text-info-header {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.6);

    @media only screen and (max-width: 767px) {
      font-size: 12px;
    }
  }

  .text-info-course-name {
    font-weight: 700;
    font-size: 22px;
    line-height: 22px;

    @media only screen and (max-width: 767px) {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
    }
  }
`;
